import { campaignBillingStatus } from 'constants/campaignConstants';
import { parseAdmin } from 'services/adminServices';
import { parseArtDesignsRequest } from 'services/campaignArtServices';
import { parseBilling, parseCampaign } from 'services/campaignServices';
import { fetchGetCampaignsGraphQL, fetchGetCampaignGraphQL } from './graphql/campaignGraphQL';

import { axiosWithToken, axios } from './axios';

export const fetchGetCampaigns = async (
  {
    page, perPage, name, campaignStatus, billingStatus, cancelToken,
  } = {
    page: null,
    perPage: null,
    name: '',
    campaignStatus: '',
    billingStatus: '',
  },
) => {
  // Use GraphQL only for campaign list
  const result = await fetchGetCampaignsGraphQL({
    first: perPage || 25,
    // Note: GraphQL uses cursor-based pagination, not page numbers
    // TODO: Implement proper cursor-based pagination
  });

  return {
    artChangeRequests: [], // Art change requests are handled separately in GraphQL
    campaigns: result.campaigns,
    totalCount: result.totalCount,
    totalPages: result.totalPages
  };
};

export const fetchGetCampaign = async ({ id }) => {
  // Use GraphQL for single campaign fetch
  return await fetchGetCampaignGraphQL({ id });
};

export const fetchAddCampaign = async (data) => {
  const response = await axiosWithToken.post('campaign', data);

  const { campaign } = JSON.parse(response.data.body);

  return parseCampaign(campaign);
};

export const fetchEditCampaign = async (data) => {
  const response = await axiosWithToken.post('campaign', data);

  const { campaign } = JSON.parse(response.data.body);

  return parseCampaign(campaign);
};

export const fetchGetCampaignAdmins = async ({ campaignId }) => {
  const response = await axiosWithToken.get('campaign/assign', {
    params: {
      campaign_id: campaignId
    }
  });

  const { result: admins } = JSON.parse(response.data.body);

  return admins.map((admin) => parseAdmin(admin));
};

export const fetchGetCampaignBilling = async ({ campaignId }) => {
  const response = await axios.get('campaign/ledger', {
    params: {
      campaign_id: campaignId
    }
  });

  const { ledger } = response.data;

  return Array.isArray(ledger) ? ledger.map((billing) => parseBilling(billing)) : [];
};

export const fetchCancelSubscription = async (data) => {
  const response = await axiosWithToken.post('campaign/cancel-billing', data);

  const { campaign_status: campaignStatus } = JSON.parse(response.data.body);

  return campaignStatus;
};

export const fetchCalculateCampaignPricing = async (data) => {
  const response = await axiosWithToken.post('campaign/recalc', data);

  return JSON.parse(response.data.body);
};

// TODO: Implement with GraphQL in future version
// export const fetchFailedCampaignPayments = async () => {
//   const response = await axiosWithToken.get('campaign', {
//     params: { perPage: 1, billing_status: campaignBillingStatus.FAILED },
//   });
//
//   const { campaigns } = JSON.parse(response.data.body);
//
//   return campaigns.length > 0;
// };

// Removed - Status filters not used in customer portal
// export const fetchGetCampaignStatuses = async () => {
//   const response = await axiosWithToken.get('campaign/status-map');
//
//   const { statusMap: statuses } = JSON.parse(response.data.body);
//
//   return Object.keys(statuses).map((key) => {
//     return { id: Number(key), label: statuses[key] };
//   });
// };
